import { render, staticRenderFns } from "./ManufacturerarchiveHistory.vue?vue&type=template&id=0f692c7e&scoped=true&"
import script from "./ManufacturerarchiveHistory.vue?vue&type=script&lang=js&"
export * from "./ManufacturerarchiveHistory.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerarchiveHistory.vue?vue&type=style&index=0&id=0f692c7e&lang=less&scoped=true&"
import style1 from "./ManufacturerarchiveHistory.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f692c7e",
  null
  
)

export default component.exports